import { useTranslations } from '@altermaind/core/i18n';
import { Button, Svg, Typography } from '@altermaind/web/ui';

type Props = {
  onBack?: () => void;
  label?: string;
};

export const GoBack = ({ label, onBack }: Props) => {
  const t = useTranslations('goBack');

  const goBack = () => {
    if (onBack) {
      onBack();
      return;
    }
    window.history.back();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <Button onClick={goBack} textAlign='left' variant='link/primary' mb='s' mt='none'>
      <Svg name='back' size='xs' />
      <Typography ml='xxxs' variant='p2'>
        {label || t('title')}
      </Typography>
    </Button>
  );
};
